<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="webcam.webcamId > 0; else addTitle">Edit Webcam</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <p>
        <mat-form-field class="edit-webcam__wideField">
          <input matInput
                 placeholder="Webcam Name *"
                 formControlName="name"
                 [(ngModel)]="selectedName">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="edit-webcam__wideField">
          <input matInput
                 placeholder="URL *"
                 formControlName="url"
                 [(ngModel)]="selectedUrl">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="edit-webcam__wideField">
          <input matInput
                 placeholder="Site/Location of Webcam *"
                 formControlName="site"
                 [(ngModel)]="selectedSite">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field>
          <mat-select placeholder="Direction/Facing *" [(value)]="selectedFacing" name="facing" formControlName="facing">
            <mat-option value="Varies">Varies</mat-option>
            <mat-option value="N">N</mat-option>
            <mat-option value="NE">NE</mat-option>
            <mat-option value="E">E</mat-option>
            <mat-option value="SE">SE</mat-option>
            <mat-option value="S">S</mat-option>
            <mat-option value="SW">SW</mat-option>
            <mat-option value="W">W</mat-option>
            <mat-option value="NW">NW</mat-option>
            <mat-option value="Center">Center</mat-option>
          </mat-select>
        </mat-form-field>
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Webcam
</ng-template>
